module.exports = __webpack_public_path__ + "media/assets/JingoLogo-c863e16e6c76bd54787c4de3166f644d.png";